import { StateCreator } from 'zustand';

// This is a placeholder the states will be updated during development.

export interface YourDetailsSlice {
  firstName: string;
  lastName: string;
  email: string;
  termsAndConditionsAccepted: boolean;
  sessionId: string;
  updateSessionId: (sessionId: string) => void;
  updateFirstName: (firstName: string) => void;
  updateLastName: (lastName: string) => void;
  updateEmail: (email: string) => void;
  updateTermsAndConditionsAccepted: (
    termsAndConditionsAccepted: boolean,
  ) => void;
  resetYourDetails: () => void;
}

export const createYourDetailsSlice: StateCreator<
  YourDetailsSlice,
  [],
  [],
  YourDetailsSlice
> = (set) => ({
  sessionId: '',
  firstName: '',
  lastName: '',
  email: '',
  termsAndConditionsAccepted: false,
  updateSessionId: (sessionId) => set(() => ({ sessionId })),
  updateFirstName: (firstName) => set(() => ({ firstName })),
  updateLastName: (lastName) => set(() => ({ lastName })),
  updateEmail: (email) => set(() => ({ email })),
  updateTermsAndConditionsAccepted: (termsAndConditionsAccepted) =>
    set(() => ({ termsAndConditionsAccepted })),
  resetYourDetails: () =>
    set(() => ({
      firstName: '',
      lastName: '',
      email: '',
      termsAndConditionsAccepted: false,
      sessionId: '',
    })),
});
